import {
  createDevice,
  getDevices,
  deleteDevice,
  listAllDevices,
  deleteDevices,
  getRFIDs,
  createRFID,
  deleteRFID,
  getBadgeHolders,
  createBadgeHolder,
  deleteBadgeHolder,
  updateBadgeHolder,
} from '@/services/api/device/device'

export default {
  namespaced: true,
  state: {
    allDevices: [],
    devices: [],
    rfids: [],
    badgeHolders: [],
    allDevicesLoading: false,
    devicesLoading: false,
    uploadDevices: [],
  },
  mutations: {
    SET_ALL_DEVICES(state, devices) {
      state.allDevices = devices
    },
    SET_ALL_DEVICES_LOADING(state, loading) {
      state.allDevicesLoading = loading
    },
    SET_DEVICES(state, devices) {
      state.devices = devices
    },
    SET_RFIDS(state, rfids) {
      state.rfids = rfids
    },
    SET_BADGE_HOLDERS(state, badgeHolders) {
      state.badgeHolders = badgeHolders
    },
    SET_UPLOAD_DEVICES(state, devices) {
      state.uploadDevices = devices
    },
    SET_LOADING(state, loading) {
      state.devicesLoading = loading
    },
  },
  actions: {
    async getDevices({ commit }, payload) {
      commit('SET_ALL_DEVICES_LOADING', true)
      return getDevices(payload)
        .then((res) => {
          commit('SET_DEVICES', res.data)
          return res
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Fetch Error',
              description: 'Failed to get devices data',
            },
            { root: true },
          )
        })
        .finally(() => commit('SET_ALL_DEVICES_LOADING', false))
    },
    async getRFIDs({ commit }, payload) {
      commit('SET_ALL_DEVICES_LOADING', true)
      return getRFIDs(payload)
        .then((res) => {
          commit('SET_RFIDS', res.data)
          return res
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Fetch Error',
              description: 'Failed to get RFID data',
            },
            { root: true },
          )
        })
        .finally(() => commit('SET_ALL_DEVICES_LOADING', false))
    },
    async getBadgeHolders({ commit }, payload) {
      commit('SET_ALL_DEVICES_LOADING', true)
      return getBadgeHolders(payload)
        .then((res) => {
          commit('SET_BADGE_HOLDERS', res.data)
          return res
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Fetch Error',
              description: 'Failed to get badge holders data',
            },
            { root: true },
          )
        })
        .finally(() => commit('SET_ALL_DEVICES_LOADING', false))
    },
    async listAllDevices({ commit }) {
      commit('SET_LOADING', true)
      return listAllDevices()
        .then((res) => {
          commit('SET_ALL_DEVICES', res.data)
          return res
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Fetch Error',
              description: 'Failed to get all devices data',
            },
            { root: true },
          )
        })
        .finally(() => commit('SET_LOADING', false))
    },
    async createDevice({ commit }, payload) {
      return createDevice(payload)
        .then((device) => {
          if (!device) return false
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Added a device',
              description: 'You have successfully added a new device',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error) // Log the full error for debugging
          let errorMessage = 'Unknown error occurred' // Default error message

          if (error.response) {
            if (error.response.status === 404) {
              errorMessage = 'The requested resource was not found.'
            } else {
              errorMessage = error.response.data.message || errorMessage
            }
          }
          commit(
            'notification/NEW',
            {
              type: 'warning',
              message: 'Create Error',
              description: Array.isArray(errorMessage)
                ? errorMessage.join('\n')
                : errorMessage,
            },
            { root: true },
          )
        })
    },
    async createRFID({ commit }, payload) {
      return createRFID(payload)
        .then((device) => {
          if (!device) return false
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Added a RFID',
              description: 'You have successfully added a new RFID',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error) // Log the full error for debugging
          let errorMessage = 'Unknown error occurred' // Default error message

          if (error.response) {
            if (error.response.status === 404) {
              errorMessage = 'The requested resource was not found.'
            } else {
              errorMessage = error.response.data.message || errorMessage
            }
          }
          commit(
            'notification/NEW',
            {
              type: 'warning',
              message: 'Create Error',
              description: Array.isArray(errorMessage)
                ? errorMessage.join('\n')
                : errorMessage,
            },
            { root: true },
          )
        })
    },
    async createBadgeHolder({ commit }, payload) {
      return createBadgeHolder(payload)
        .then((device) => {
          if (!device) return false
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Added a badge holder',
              description: 'You have successfully added a new badge holder',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error) // Log the full error for debugging
          let errorMessage = 'Unknown error occurred' // Default error message

          if (error.response) {
            if (error.response.status === 404) {
              errorMessage = 'The requested resource was not found.'
            } else {
              errorMessage = error.response.data.message || errorMessage
            }
          }
          commit(
            'notification/NEW',
            {
              type: 'warning',
              message: 'Create Error',
              description: Array.isArray(errorMessage)
                ? errorMessage.join('\n')
                : errorMessage,
            },
            { root: true },
          )
        })
    },
    async updateBadgeHolder({ commit }, payload) {
      return updateBadgeHolder(payload)
        .then((device) => {
          if (!device) return false
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Updated badge holder',
              description: 'You have successfully updated the badge holder',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error)
          let errorMessage = 'Unknown error occurred'

          if (error.response) {
            if (error.response.status === 404) {
              errorMessage = 'The requested resource was not found.'
            } else {
              errorMessage = error.response.data.message || errorMessage
            }
          }
          commit(
            'notification/NEW',
            {
              type: 'warning',
              message: 'Update Error',
              description: Array.isArray(errorMessage)
                ? errorMessage.join('\n')
                : errorMessage,
            },
            { root: true },
          )
        })
    },
    async deleteDevice({ commit }, payload) {
      return deleteDevice(payload)
        .then((device) => {
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Device deleted',
              description: 'You have successfully deleted a device',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Delete Error',
              description: 'Failed to delete a device',
            },
            { root: true },
          )
        })
    },
    async deleteRFID({ commit }, payload) {
      return deleteRFID(payload)
        .then((device) => {
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'RFID deleted',
              description: 'You have successfully deleted a RFID',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Delete Error',
              description: 'Failed to delete a RFID',
            },
            { root: true },
          )
        })
    },
    async deleteBadgeHolder({ commit }, payload) {
      return deleteBadgeHolder(payload)
        .then((device) => {
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Badge Holder deleted',
              description: 'You have successfully deleted a badge holder',
            },
            { root: true },
          )
          return device
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Delete Error',
              description: 'Failed to delete a badge holder',
            },
            { root: true },
          )
        })
    },
    async deleteDevices({ commit }, payload) {
      return deleteDevices(payload)
        .then((device) => {
          commit(
            'notification/NEW',
            {
              type: 'success',
              message: 'Devices deleted',
              description: 'You have successfully deleted a devices',
            },
            { root: true },
          )
          return vehicle
        })
        .catch((error) => {
          console.error(error)
          commit(
            'notification/NEW',
            {
              type: 'error',
              message: 'Delete Error',
              description: 'Failed to delete a devices',
            },
            { root: true },
          )
        })
    },
    async setUploadDevices({ commit }, payload) {
      commit('SET_UPLOAD_DEVICES', payload)
    },
  },
  getters: {},
}
